import React from 'react';

import BannerCase from './banner-case';
import ContentCase from './content-case';

const TitleCase = ({ img, video, className = '', caseName, listTitle, listPath }) => {
    return (
        <>
            <BannerCase img={img} video={video} className={className} listPath={listPath} />
            <ContentCase caseName={caseName} listTitle={listTitle} />
        </>
    );
};

export default TitleCase;
